import { useEffect, useState } from 'react';

import { useEnableUnifiedMenu } from 'hooks/use-enable-unified-menu';
import { useMinimalCart } from 'hooks/use-minimal-cart';
import { selectors, useAppSelector } from 'state/global-state';

export interface IHydrationStatus {
  processed: boolean;
  executing: boolean;
  error: boolean;
}

interface IUseHydrationParams {
  setShouldSkipPriceOrder?: (value: boolean) => void;
}

export const useHydration = ({ setShouldSkipPriceOrder }: IUseHydrationParams = {}) => {
  const minimalCartEntries = useAppSelector(selectors.ordering.selectMinimalCartEntries);
  const [hydrationStatus, setHydrationStatus] = useState<IHydrationStatus>({
    processed: false,
    executing: false,
    error: false,
  });

  const isUnifiedMenuEnabled = useEnableUnifiedMenu();
  const { hydrateMinimalCart } = useMinimalCart();

  useEffect(() => {
    if (isUnifiedMenuEnabled && minimalCartEntries.length && !hydrationStatus.processed) {
      setHydrationStatus(status => ({ ...status, processed: true, executing: true }));
      hydrateMinimalCart().then((success: boolean) => {
        if (!success) {
          setShouldSkipPriceOrder?.(false);
        }
        return setHydrationStatus(status => ({ ...status, executing: false, error: !success }));
      });
    } else {
      setHydrationStatus(status => ({ ...status, processed: true }));
    }
  }, [
    hydrateMinimalCart,
    hydrationStatus.processed,
    isUnifiedMenuEnabled,
    minimalCartEntries.length,
    setShouldSkipPriceOrder,
  ]);

  return { hydrationStatus };
};
